/**
 * @fileoverview POST handler for the "/apps/:app_group_id/custom_attributes_settings_create" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdCustomAttributesSettingsCreateCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdCustomAttributesSettingsCreateProps,
  AppsAppGroupIdCustomAttributesSettingsCreateResult,
} from "./types";

export const postAppsAppGroupIdCustomAttributesSettingsCreate = reactQueryMutationAdapter(
  appsAppGroupIdCustomAttributesSettingsCreateCacheKeys,
  (
    props: PostAppsAppGroupIdCustomAttributesSettingsCreateProps
  ): Promise<AppsAppGroupIdCustomAttributesSettingsCreateResult> => {
    return fetch(`/apps/${props.appGroupId}/custom_attributes_settings_create`, "POST", props);
  }
);
